import { Link } from "react-router";

import type { MoveTask } from "@/lib/providers";
import { moveMark } from "@/lib/task";

/**
 * Задача FBS в строке ленты движений — ОДИН компонент на обе ленты.
 *
 * Ленты две (серии и баркода), а вопрос один: этот переезд сделала складская
 * задача или человек руками. Две копии подписи разошлись бы ровно тогда, когда
 * их начали бы сверять глазами, — как разошлись бы и две копии самой ленты.
 *
 * Три исхода различает `lib/task.ts::moveMark`, и различение несущее: пустая
 * привязка при недоступной базе задач (песочная полоса) — это «не знаю», а не
 * «двигали руками». Рисуются они поэтому РАЗНЫМИ словами, а не одним прочерком.
 */
export function TaskMark({
  task,
  known,
}: {
  task: MoveTask | null;
  known: boolean;
}) {
  const mark = moveMark(task, known);

  if (mark.kind === "task") {
    return (
      <span className="flex flex-col items-end md:items-start" title={mark.title}>
        <Link
          to={mark.href}
          className="tnum whitespace-nowrap text-accent-text underline decoration-dotted underline-offset-2 hover:no-underline"
        >
          {mark.label}
        </Link>
        {/* Статус ПЛОЩАДКИ — второй строкой и всегда с её именем. Первая
            строка говорит, что сделал склад («упаковка»), эта — что с вещью у
            ВБ или Ozon, и без имени площадки рядом второй статус читался бы
            как продолжение первого (замечание владельца 09.09.26). Ссылкой не
            становится: карточку открывает номер задачи, а это про чужую
            систему. */}
        {mark.mp ? (
          <span className="whitespace-nowrap text-[11px] text-fg-muted">
            {mark.mp}
          </span>
        ) : null}
      </span>
    );
  }

  if (mark.kind === "manual") {
    return (
      <span
        className="whitespace-nowrap text-fg-muted"
        title="Задачи FBS за этим перемещением нет: вещь двигали руками — выемка, возврат, инвентаризация"
      >
        руками
      </span>
    );
  }

  return (
    <span
      className="whitespace-nowrap text-fg-muted"
      title="Базу задач FBS прочитать не удалось: в песочной полосе её нет вовсе. Это «не знаю», а не «перемещение ручное»"
    >
      нет связи
    </span>
  );
}
